export const hr = {
  meta: {
    title: "Hadron Energy Poland | Litijevi baterijski sustavi i električni vanbrodski motori",
    description: "Prilagođeni baterijski paketi i električni vanbrodski pogoni za čamce, e-mobilnost, pohranu energije i dronove — sastavljani, certificirani i servisirani u Poljskoj. Litijeva energija na kojoj možete graditi: projektirana globalno, podržana u Europi.",
  },
  nav: { about: "O nama", products: "Baterijski sustavi", specs: "Vanbrodski motori", tech: "Tehnologija / I&R", contact: "Kontakt", quote: "Zatraži konfiguraciju" },
  topbar: { badge: "Europsko sastavljačko i jamstveno središte" },
  hero: {
    eyebrow: "Litijeva energija na kojoj možete graditi — projektirana globalno, podržana u Europi",
    l1: "Napredna litijeva energija",
    l2: "& električni morski",
    l3: "pogonski sustavi",
    sub: "Prilagođeni baterijski paketi i električni vanbrodski pogoni za čamce, e-mobilnost, pohranu energije i dronove. Sastavljani, certificirani i servisirani u Poljskoj",
    cta1: "Istraži liniju proizvoda",
    cta2: "Kontaktiraj europsko središte",
    chip1: "Od 2014. — globalna skupina čiste energije",
    chip2: "CE · CB · UN38.3 · ISO 9001 · SGS",
    chip3: "Preko 4.000 m² proizvodnih kapaciteta",
    scroll: "Pomaknite dolje",
  },
  marquee: ["CE certifikat", "CB shema", "UN 38.3", "ISO 9001", "SGS provjereno", "Kompletno rješenje napajanja", "Pogon 4.000+ m²", "I&R solid-state", "Pogon bez emisija", "Hadron Energy Poland"],
  synergy: {
    eyebrow: "02 — Globalna sinergija",
    heading: "Jedna skupina. Tri kontinenta. Jedan standard energije.",
    lead: "Hadron Energy Poland je europska baza za sastavljanje, regionalni distributivni centar EU i službeno središte jamstva i servisiranja skupine Hadron — većinski vlasnik je skupina iz Singapura koja posjeduje i Hadron China (Wuxi Hadron New Energy Tech Co., Ltd.).",
    n1t: "Wuxi, Kina",
    n1d: "Sjedište I&R i proizvodnje — odabir ćelija, istraživanje materijala i proizvodnja paketa u punom opsegu.",
    n2t: "Singapur",
    n2d: "Vlasnička skupina — globalno upravljanje, kapital i strateški smjer.",
    n3t: "Gdów, Poljska",
    n3d: "Europska baza sastavljanja — linije za male pakete, distribucija u EU i službeno središte jamstva i servisiranja.",
    s1l: "Ciklusa LiFePO₄ (ESS)",
    s2l: "Proizvodni prostor",
    s3l: "Vršna struja — dirt bike paketi",
    s4l: "Osnovano",
    osTitle: "Kompletno rješenje napajanja",
    os: ["Odabir i klasifikacija ćelija", "Prilagođen dizajn krugova i strukture", "Montaža modula i paketa", "Integracija BMS-a", "Punjači i priključnici"],
    certsLabel: "Certifikati kvalitete i sigurnosti",
    missionLabel: "Misija",
    visionLabel: "Vizija",
    mission: "Osnažiti tvrtke i potrošače inovativnim zelenim tehnološkim rješenjima za bolju kvalitetu života.",
    vision: "Postati globalni lider u sustavima električnih pogona za zrakoplove i brodove u Poljskoj i Europi.",
    brandNote: "Hadron — poput plime: neprestano naprijed na električnom valu",
    partnerTag: "Partner u razvoju",
    partnerTitle: "Partner u razvoju, a ne trgovina gotovim proizvodima",
    partnerText: "Ne prodajemo gotove proizvode. Zajedno razvijamo vaš paket — odabir ćelija, prilagođen dizajn krugova i strukture, BMS softver, mehaniku i podršku pri certifikaciji — sustav napajanja izrađen oko vaše platforme, a ne prilagođen naknadno.",
    supplyTag: "Stabilnost opskrbnog lanca",
    supplyTitle: "Baterijski paketi bez kineskih komponenti i ćelija",
    supplyText: "Za projekte koji zahtijevaju geopolitički otporan opskrbni lanac, gradimo pakete bez kineskih komponenti: ćelije iz Japana, Koreje ili Malezije, elektronika sastavljena lokalno u Poljskoj — spremno za reviziju i izvoz.",
  },
  products: {
    eyebrow: "03 — Linija proizvoda",
    heading: "Energija za vodu, kopno i dom.",
    lead: "Četiri projektirane platforme, jedan proizvodni standard — od pogona bez emisija do kućne pohrane energije.",
    cta: "Zatraži konfiguraciju",
    datasheet: "Tehnički list (PDF)",
    punch: ["Tiha energija bez emisija za svaki trup", "Više dosega i snage — uključi i kreni", "Baterije koje razgovaraju s vašim potisnikom", "Pohrana koja se isplati godinama", "Pogon izgrađen oko vaše misije"],
    items: [
      {
        tag: "Električni pogon", title: "Električni vanbrodski motori", img: "/images/outboard_studio.jpg",
        desc: "Vrlo učinkovit električni pogon koji zamjenjuje benzinske motore na jedrilicama, ribarskim, radnim čamcima i dingijima — povezan s aplikacijom Hadron Marine.",
        f: ["Zamjena bez emisija za benzinske motore", "Za jedrilice, ribarske i radne čamce i dingije", "Aplikacija Hadron Marine: GPS vizualizacija dometa", "Digitalni mjerači i bežična OTA ažuriranja", "Digitalni zaslon: snaga, preostali doseg, stanje baterije i napon u stvarnom vremenu", "Električni start jednim gumbom — podesiva maksimalna snaga, sigurnije za djecu i čamce u najam"],
        chips: ["HD-X02", "HD-X05", "12–144 V"],
      },
      {
        tag: "E-mobilnost", title: "Baterije za e-mobilnost i dirt bike", img: "/images/dirtbike_battery.jpg",
        desc: "Prilagođeni paketi za velike struje od 48 V, 60 V, 72 V i 96 V — uključujući nadogradnje za dirt bike motocikle Sur-Ron i Talaria s vlastitom Bluetooth BMS aplikacijom.",
        f: ["Paketi 48 / 60 / 72 / 96 V", "Sur-Ron i Talaria paketi: 60 V 56 Ah / 72 V 50 Ah", "Do 350 A kontinuirano · 550 A vršno", "Priključci QS8/QS10 · BMS aplikacija Android/iOS"],
        chips: ["350 A kont.", "550 A vršno", "QS8 / QS10"],
      },
      {
        tag: "Marina", title: "Morske baterije i električni čamci", img: "/images/marine_battery.jpg",
        desc: "Snažni morski baterijski paketi u NCM i LiFePO₄ tehnologiji do 200 Ah, pametni BMS s CAN / RS485 komunikacijom i sabirnice bakar-aluminij niskog zagrijavanja.",
        f: ["NCM / LiFePO₄ — do 200 Ah", "Pametni BMS: CAN i RS485 protokoli", "Sabirnice bakar-aluminij za velike struje", "Nisko zagrijavanje pod opterećenjem", "Pametni BMS kompatibilan s više modela potisnika", "Standardizirani modularni dizajn — konfigurabilno na zahtjev"],
        chips: ["200 Ah", "CAN / RS485", "NCM · LiFePO₄"],
      },
      {
        tag: "Pohrana energije", title: "ESS i pametni dom", img: "/images/ess_wall.jpg",
        desc: "Kućni ESS od 5 kWh zidne izvedbe do 20 kWh u konfiguraciji slaganja (LiFePO₄, preko 5.000 ciklusa), industrijski ormari 38,4 V / 76,8 V s hlađenjem te napajanja za pametni dom.",
        f: ["Kuća: 5 kWh zid → 20 kWh ormar", "LiFePO₄ · >5.000 ciklusa", "Industrija: 38,4 V / 76,8 V, hlađeno", "Napajanja za alat, rolete i uređaje"],
        chips: ["5–20 kWh", ">5.000 ciklusa", "LiFePO₄"],
      },
      {
        tag: "Zrakoplovstvo", title: "VTOL i dronski pogoni", img: "/images/vtol_drone.jpg",
        desc: "Električni motori visokih okretaja za VTOL zrakoplove i dronove — s uslugama prilagobe pogona specifičnim zahtjevima korisnika.",
        f: ["Motori visokih okretaja za VTOL i dronove", "Prilagoba specifičnim zahtjevima korisnika", "Integracija: baterija · motor · ECU", "Tržište raste 13,9 % godišnje do 2029."],
        chips: ["VTOL", "Dronovi", "Baterija · Motor · ECU"],
      },
    ],
  },
  specs: {
    eyebrow: "04 — Tehnički podaci",
    heading: "Električni vanbrodski pogoni u usporedbi.",
    lead: "Referentna ponuda Hadron vanbrodskih pogona — od kompaktnih 1–2 KS do vrhunskog modela ekvivalenta 90 KS.",
    rows: { model: "Model", voltage: "Napon", power: "Ulazna snaga", equiv: "Ekvivalentna snaga", rpm: "Maks. okretaji", cooling: "Hlađenje", control: "Upravljanje", weight: "Masa" },
    m1: { name: "HD-X02", voltage: "12 / 24 V", power: "0,5–1,1 kW", equiv: "1–2 KS", rpm: "—", cooling: "Hlađenje vodom", control: "Ručno kormilo (tiller)", weight: "8 kg" },
    m2: { name: "HD-X05 · 20 KS", voltage: "48–72 V", power: "15 kW", equiv: "20 KS", rpm: "≤ 6.000", cooling: "Hlađenje slatkom vodom", control: "—", weight: "30 kg" },
    m3: { name: "HD-X05 · 90 KS", voltage: "144 V", power: "66 kW", equiv: "90 KS", rpm: "≤ 5.500", cooling: "Hlađenje slatkom vodom", control: "—", weight: "115 kg" },
    note: "Kompletni tehnički listovi, opcije montaže i kombinacije baterija — na zahtjev europskog središta.",
    marketsTitle: "Kretanje tržišta",
    markets: [
      { v: "43,25 mlrd $", l: "Tržište električnih brodova do 2030. — s 8,96 mlrd $ 2025." },
      { v: "67,64 mlrd $", l: "Tržište komercijalnih dronova do 2029. — s 24,5 mlrd $ 2024." },
      { v: "13,9 %", l: "Godišnji rast (CAGR) tržišta dronova" },
    ],
    datasheet: "Tehnički list vanbrodskih motora (PDF)",
  },
  tech: {
    eyebrow: "05 — Tehnologija i I&R",
    heading: "Znanost o materijalima prije marketinga.",
    lead: "Istraživanja iz sjedišta u Wuxiju putem skupine izravno ulaze u svaki paket sastavljen u Poljskoj.",
    cards: [
      { t: "Solid-state istraživanja", d: "Granatni kruti elektroliti za novu generaciju sigurnih litijevih ćelija." },
      { t: "Materijali s promjenom faze", d: "PCM termičko upravljanje koje stabilizira ćelije pod ekstremnim opterećenjem." },
      { t: "ALD-Al₂O₃", d: "Atomsko nanošenje slojeva za sigurnije litijeve ćelije i dulji vijek trajanja." },
    ],
    powertrainTitle: "Integrirani pogonski sustav",
    powertrain: [
      { t: "Litijeva baterija", d: "Visoka gustoća energije uz brzo punjenje i sigurnost." },
      { t: "Električni motor", d: "Visoka učinkovitost naprednim hlađenjem." },
      { t: "Upravljačka jedinica", d: "Napredna elektronička upravljačka jedinica (ECU)." },
    ],
    imgCaption: "Montaža paketa — Gdów, Poljska",
    fcTitle: "4C proizvodna načela",
    fc: [
      { t: "Čista okruženja", d: "Kontrolirani uvjeti sastavljanja od ćelije do paketa." },
      { t: "Ispravan rad", d: "Validirani procesi na svakom radnom mjestu, svakoj smjeni." },
      { t: "Dosljedni proizvodi", d: "Jedan standard kvalitete u Kini, Singapuru i Poljskoj." },
      { t: "Stalno poboljšanje", d: "Ugrađena pratljivost i iteracija u svakoj seriji." },
    ],
  },
  contact: {
    eyebrow: "08 — Kontakt",
    heading: "Napajmo vaš sljedeći proizvod.",
    lead: "Inženjer će odgovoriti s predloženom konfiguracijom u roku od 2 radna dana — na poljskom, engleskom, njemačkom, francuskom, talijanskom ili hrvatskom.",
    addrLabel: "Adresa", phoneLabel: "EU prodaja i podrška", emailLabel: "E-mail",
    f: {
      name: "Ime i prezime", company: "Tvrtka", email: "E-mail", interest: "Proizvod od interesa",
      interests: ["Električni vanbrodski motori", "E-mobilnost i dirt bike baterije", "Morske baterije", "ESS i pametni dom", "VTOL i dronski pogoni", "Paketi po mjeri"],
      msg: "Poruka", submit: "Pošalji upit", sending: "Slanje…",
      attach: "Priložite datoteku s zahtjevima", attachSize: "maks. 10 MB", attachBad: "Dopuštene su samo PDF ili CSV datoteke do 10 MB.",
      success: "Upit primljen — odgovorit ćemo u roku od 2 radna dana.",
      errorGeneric: "Nešto je pošlo po zlu — pokušajte ponovno.",
      errRequired: "Ispunite ime, valjanu e-mail adresu i poruku.",
    },
  },
  stakes: {
    eyebrow: "01 — Što je u igri",
    empathy: "Vaš je proizvod toliko pouzdan koliko je pouzdana baterija u njemu.",
    sub: "Treba vam paket ili pogon prilagođen vašem naponu, kućištu i stazi certifikacije.",
    lead2: "Znamo koliko košta kvar napajanja daleko od podrške. Kupnja s druge strane svijeta obično znači duge rokove, spore zahtjeve i nikoga tko se može nazvati kad uređaj zakaže u terenu.",
    risk: "Taj rizik pada na vas — na vaše kupce, vaše jamstvo i vaš ugled.",
    items: ["Nema lokalne podrške kad paket zakaže", "Jamstveni zahtjevi mjesecima zaglavljeni u inozemstvu", "Pitanja revizije opskrbnog lanca na koja nemate odgovor", "Uređaji koji zakažu u terenu bez ikoga u blizini da ih popravi", "Povrati i troškovi jamstva koji grizu vašu maržu", "Projekti blokirani revizijama opskrbnog lanca"],
    philosophy: "Europski proizvod zaslužuje dobavljača koji ga stoji iza u Europi.",
  },

  plan: {
    eyebrow: "06 — Kako to funkcionira",
    heading: "Tri koraka do pouzdane energije.",
    steps: [
      { t: "Opišite nam svoju primjenu", d: "Napon, kapacitet, prostor, zahtjevi certifikacije — ili jednostavno što vaš proizvod mora raditi." },
      { t: "Dobijte konfiguraciju i uzorak", d: "Naši inženjeri biraju ćelije, BMS i kućište te šalju specifikaciju i prototip za testiranje." },
      { t: "Gradite s europskom pozadinom", d: "Paketi se sastavljaju i testiraju u Poljskoj, uz jamstvo i servis od istog tima." },
    ],
    success: "Proizvodi koji rade na vodi, na stazi i u zraku. Jamstvo i servis rješavaju se u Europi, u tjednima a ne mjesecima. Opskrbni lanac koji možete dokumentirati i obraniti.",
    cta: "Zatraži konfiguraciju",
  },

  story: {
    eyebrow: "Studija primjene",
    heading: "Od specifikacije do europske pozadine: morski paket 60 V.",
    challengeLabel: "Izazov", challenge: "Proizvođač električnih čamaca trebao je paket od 60 V koji komunicira s potisnicima, izdržava zahtjevne radne cikluse i dolazi s dokumentacijom koja prolazi EU reviziju — bez linije podrške na drugom kraju svijeta.",
    buildLabel: "Izvedba", build: "Hadronovi inženjeri specificirali su NCM konfiguraciju 60 V 150 Ah (17S1P) s pametnim BMS-om preko CAN / RS485, sabirnicama bakar-aluminij za velike struje i kompatibilnošću s više modela potisnika — sastavljeno i testirano u pogonu Gdów; ćelije izvan Kine dostupne za projekte osjetljive na opskrbni lanac.",
    resultLabel: "Rezultat", result: "Paket koji se može servisirati, jamčiti i dokumentirati u Europi — isti tim vodi zahtjev od prvog poziva do popravljenog uređaja.",
    chips: ["60 V · 150 Ah (17S1P)", "150 A kontinuirano", "CAN / RS485", "Ćelije izvan Kine na zahtjev"],
    cta: "Zatraži konfiguraciju",
    note: "Referentna konfiguracija iz Hadronovog programa — vaša primjena dobiva isti tretman: razvijeno oko vaše platforme, s pozadinom u Europi.",
  },

  faq: {
    eyebrow: "07 — FAQ",
    heading: "Odgovori za motore i za ljude.",
    items: [
      { q: "Gdje se proizvode Hadronovi proizvodi?", a: "I&R i proizvodnja u punom opsegu nalaze se u sjedištu u Wuxiju, Kina; baterijski paketi za europsko tržište sastavljaju se u našem postrojenju u Gdówu, Poljska — koje je ujedno distributivni centar EU i službeno središte jamstva i servisiranja." },
      { q: "Prodajete li standardne proizvode ili razvijate pakete po mjeri?", a: "Mi smo partner u razvoju, a ne trgovina gotovim proizvodima: od odabira ćelija i prilagođenog dizajna krugova i strukture do BMS softvera, mehanike i podrške pri certifikaciji — svaki se paket razvija oko vaše platforme." },
      { q: "Možete li isporučiti pakete bez kineskih komponenti?", a: "Da. Za projekte osjetljive na opskrbni lanac gradimo pakete bez kineskih komponenti — ćelije iz Japana, Koreje ili Malezije, elektronika sastavljena lokalno u Poljskoj; spremno za reviziju i izvoz." },
      { q: "Koje certifikate imaju Hadronovi paketi?", a: "Naš temelj kvalitete i sigurnosti: CE, CB, UN38.3, ISO 9001 i SGS provjera u cijelom proizvodnom lancu." },
      { q: "Koji su vanbrodski modeli dostupni?", a: "HD-X02 (12/24 V, 0,5–1,1 kW, ekvivalent 1–2 KS, 8 kg, kormilo iza), HD-X05 20 KS (48–72 V, 15 kW, 30 kg) i HD-X05 90 KS (144 V, 66 kW, 115 kg) — s aplikacijom Hadron Marine: GPS doseg, digitalni mjerači i OTA ažuriranja." },
      { q: "Podržavate li dirt bike motocikle Sur-Ron i Talaria?", a: "Da — nadogradni paketi 60 V 56 Ah i 72 V 50 Ah, do 350 A kontinuirano i 550 A vršno, priključci QS8/QS10 i Bluetooth BMS aplikacija za Android i iOS." },
    ],
  },

  footer: {
    tagline: "Pametna rješenja čiste energije — projektirana u Wuxiju, upravljana iz Singapura, sastavljena i servisirana u Gdówu, Poljska.",
    disclaimer: "Većinski vlasnik Hadron Energy Poland sp. z o.o. je vlasnička skupina iz Singapura koja posjeduje i Hadron China (Wuxi Hadron New Energy Tech Co., Ltd.).",
    rights: "Sva prava pridržana.",
    privacy: "Politika privatnosti",
    imprint: "Pravne informacije",
    hub: "Europsko sastavljačko i servisno središte",
  },
};
